import { render } from "./infoOfCorruption.vue?vue&type=template&id=4f1ca28c"
import script from "./infoOfCorruption.vue?vue&type=script&lang=js"
export * from "./infoOfCorruption.vue?vue&type=script&lang=js"

import "./infoOfCorruption.vue?vue&type=style&index=0&id=4f1ca28c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__